import type { Resource } from '@/interfaces/resourceInterface';

// https://webpack.js.org/guides/web-workers/
// https://medium.com/js-dojo/using-web-workers-vue-applications-3de99f4f3371
// https://ourcodeworld.com/articles/read/1549/how-to-use-web-workers-in-vuejs
// https://blog.openreplay.com/optimizing-the-performance-of-your-vue-apps-using-web-workers/
const worker = new Worker(new URL('./searchWorkerScript.ts', import.meta.url));

export const searchWorker = {
	filterResources: async (search: string, resources: Resource[]): Promise<Resource[]> => {
		return new Promise((resolve, reject) => {
			if (!search) {
				return resolve(resources);
			}

			worker.postMessage({
				search,
				resources: JSON.parse(JSON.stringify(resources)),
			});

			worker.onmessage = ({ data: { resources } }: { data: { resources: Resource[] } }) => {
				resolve(resources);
			};

			worker.onerror = (e: Event) => {
				reject(e);
			};
		});
	},
};
